import { Card, icons, Separator, SeparatorType, useModal, sizing } from '@chillibean/component-library';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { AdminHeroBox } from '../../../../../HeroBox/AdminHeroBox/AdminHeroBox';
import { AdminList } from '../../components/container';
import { FooterButtons } from '../../components/container/FooterButtons';
import { StudyProcedureTaskDefinitionModal } from './components/container';

export function StudyProcedureTasksPage() {
  // HOOKS
  // Store
  const { data: protocol, loading } = useSelector((state) => state.protocolReducer.protocol);
  const { data: roles } = useSelector((state) => state.rolesReducer.roles);
  // Custom
  const {
    closeModal: closeTaskModal,
    data: selectedTask,
    modalOpen: taskModalOpen,
    openModal: openTaskModal,
  } = useModal();

  const onClick = (id) => {
    if (protocol?.locked) return;
    const taskToSelect = protocol.studyProcedureTaskDefinitions.find((task) => task.id === id);
    openTaskModal(taskToSelect);
  };

  return (
    <>
      <StudyProcedureTaskDefinitionModal
        onClose={closeTaskModal}
        onSuccess={closeTaskModal}
        studyProcedureTaskDefinition={selectedTask}
        visible={taskModalOpen}
      />
      <Container>
        <AdminHeroBox
          button={{
            disabled: protocol?.locked,
            loading: false,
            onClick: () => openTaskModal(),
            text: 'Create New',
          }}
          content="A task is a required action that must be performed for every assessment. Tasks must be completed before an assessment can be marked as complete. Tasks can be assigned to a specific user role, and only users with that role will be able to complete the task."
          disabled={protocol?.locked}
          header="Task Definition List"
          icon={icons.baselineFormatBulletList}
          loading={loading}
          subHeader="Task Definitions"
        />
        {!loading && !protocol?.studyProcedureTaskDefinitions.length && <Card disabled>No tasks defined</Card>}
        {(loading || Boolean(protocol?.studyProcedureTaskDefinitions.length)) && (
          <AdminList
            elements={
              protocol
                ? protocol.studyProcedureTaskDefinitions.map((task) => {
                    return {
                      ...task.listParams({ locked: protocol?.locked, onClick: onClick }),
                      subHeader: (
                        <RoleWrapper>
                          {task.roleIds.map((roleId, index) => (
                            <React.Fragment key={roleId}>
                              <div key={roleId}>{roles?.find((role) => role.id === roleId)?.name}</div>
                              {index < task.roleIds.length - 1 && <Separator type={SeparatorType.CIRCLE} />}
                            </React.Fragment>
                          ))}
                        </RoleWrapper>
                      ),
                    };
                  })
                : []
            }
            loading={loading}
          />
        )}
        <FooterButtons />
      </Container>
    </>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizing.medium};
`;

const RoleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${sizing.small};
  flex-wrap: wrap;
`;

export default StudyProcedureTasksPage;
